import { getSubdomainLinkServerSideProps } from "utils/server/link";
import ExchangeShortLinkWrapper from "components/Exchange/ShortLink/Standard";

const TestShowLink = ExchangeShortLinkWrapper;

export const getServerSideProps = getSubdomainLinkServerSideProps;

export default TestShowLink;
